import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Api from '../Apis';
import { AppLoading } from '../Loading';
import { DeletedNav } from './DeletedNav';
import { DisplayResults } from '../helper/DisplayResult';
import { DisplayRecords } from '../helper/DisplayRecords';

export const Comvert = () => {

    const fromTimeoutRef = useRef(null);
    const toTimeoutRef = useRef(null);
    const [productComponents,setProductComponents] = useState([])
    const [productComponentsTo,setProductComponentsTo] = useState([])
    const [fromSearchTerm,setFromSearchTerm] = useState("")
    const [toSearchTerm,setToSearchTerm] = useState("")
    const [autoRefresh,setAutoRefresh] = useState(true)
    const [loading,setLoading] = useState(false)
    const [returns,setReturns] = useState([])
    const [displayResults,setDisplayResults] = useState(false)
    const [displayRecords,setDisplayRecords] = useState(false)
    const [fromQuantity,setFromQuantity] = useState(0);
    const [toQuantity,settoQuantity] = useState(0);
    const [toId,setToId] = useState(0);
    const [fromId,setFromId] = useState(0);

    const fromProduct = productComponents.find(comp => String(comp.price_id) === String(fromId))
    const toProduct = productComponentsTo.find(comp => String(comp.price_id) === String(toId))
    const fromProductName = fromProduct?.product_name || fromId
    const toProductName = toProduct?.product_name || toId
    const fromTypeName = fromProduct?.type_name || ""
    const toTypeName = toProduct?.type_name || ""

    const conversionRecords = [
        {
            "from_product": fromProductName,
            "from_type": fromTypeName,
            "from_quantity": fromQuantity,
            "to_product": toProductName,
            "to_type": toTypeName,
            "to_quantity": toQuantity
        }
    ]

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true)

        const inputs = {
                "from_quantity":fromQuantity,
                "to_quantity":toQuantity,
                "from_product": fromId,
                "to_product": toId,
                "user": localStorage.getItem("username")
            }
        axios.post(Api.comvert.value + "/", inputs,{headers: Api.Token}).then(res=>{
            setReturns(res.data)
            setDisplayRecords(false)
            setDisplayResults(true)
            setFromId(0)
            setToId(0)
            setFromQuantity(0)
            settoQuantity(0)
            setFromSearchTerm("")
            setToSearchTerm("")
            setAutoRefresh(!autoRefresh)
        }).catch((e)=>{
            console.log(e)
            alert("Failed to submit data")
        }).finally(()=> setLoading(false))
    };

    const handleCancel = () => {
        setFromId(0)
        setToId(0)
        setFromQuantity(0)
        settoQuantity(0)
        setDisplayRecords(false)
    }

    const handleKeyPressFrom = () => {
        if (fromTimeoutRef.current) {
            clearTimeout(fromTimeoutRef.current);
        }

        fromTimeoutRef.current = setTimeout(() => {
            if(fromSearchTerm && fromSearchTerm.length >2){
                setLoading(true)
                axios.get(Api.products.value + "/getProductsByProductName/" + fromSearchTerm,{headers: Api.Token}).then(res=>{
                    setProductComponents(res.data)
                }).catch((e)=>{
                    console.log(e)
                    alert("Failed to fetch data")
                }).finally(()=>setLoading(false))
            
            }
        }, 2000);
    };

    const handleKeyPressTo = () => {
        if (toTimeoutRef.current) {
            clearTimeout(toTimeoutRef.current);
        }

        toTimeoutRef.current = setTimeout(() => {
            if(toSearchTerm && toSearchTerm.length >2){
                setLoading(true)
                axios.get(Api.products.value + "/getProductsByProductName/" + toSearchTerm,{headers: Api.Token}).then(res=>{
                    setProductComponentsTo(res.data)
                }).catch((e)=>{
                    console.log(e)
                    alert("Failed to fetch data")
                }).finally(()=>setLoading(false))
            
            }
        }, 2000);
    };

    useEffect(() => {
        return () => {
            if (fromTimeoutRef.current) {
              clearTimeout(fromTimeoutRef.current);
            }
            if (toTimeoutRef.current) {
              clearTimeout(toTimeoutRef.current);
            }
        };
    },[autoRefresh])

    
    return (
        <div>
            <DeletedNav />
            {displayResults && <DisplayResults returns={[returns]} setDisplay={setDisplayResults} />}
            {displayRecords && <DisplayRecords
                rows={['from_product', 'from_type', 'from_quantity', 'to_product', 'to_type', 'to_quantity']}
                inputs={conversionRecords}
                removeInputGroup={handleCancel}
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
            />}
            <form onSubmit={(e) => {
                    e.preventDefault()
                    setDisplayRecords(true)
                }
            } className='form was-validated'>
                <div className='mt-2'>
                    <h2 className='text-center'>Import New Products</h2>
                    <div className="row">
                        <div className="col-md-6 first_div">
                            <label className="form-label">From Product</label>
                            <div>
                                <input
                                    value={fromSearchTerm}
                                    type="text" required
                                    onChange={e=>setFromSearchTerm(e.target.value)}
                                    onKeyUp={handleKeyPressFrom}
                                    className="form-control"
                                    
                                />
                                <select required name="price_id" value={fromId}  onChange={(e) => setFromId(e.target.value)} className="form-select mt-2" id="">
                                    <option value="">See results</option>
                                    {
                                        productComponents.length > 0? productComponents.map((comp,index) =>(
                                            <option key={index} value={comp.price_id}>
                                                {comp.product_name}-{comp.category_name}-
                                                {comp.type_name}-{comp.quantity_remain}P-
                                                {comp.min_price}rwf
                                                </option>
                                        )):<option>no product</option>
                                    }
                                </select>
                            </div>
                            <label className="form-label">Quantity</label>
                            <input required min="1"
                                type="number"
                                name="quantity_used"
                                value={fromQuantity}
                                onChange={(e) => setFromQuantity(e.target.value)}
                                className="form-control"
                            /> 
                        </div>
                        
                        <div className="col-md-6 first_div">
                            <label className="form-label">To Product</label>
                            <div>
                                <input
                                    value={toSearchTerm}
                                    type="text" required
                                    onChange={e=>setToSearchTerm(e.target.value)}
                                    onKeyUp={handleKeyPressTo}
                                    className="form-control"
                                    
                                />
                                <select required name="price_id" value={toId}  onChange={(e) => setToId(e.target.value)} className="form-select mt-2" id="">
                                    <option value="">See results</option>
                                    {
                                        productComponentsTo.length > 0? productComponentsTo.map((comp,index) =>(
                                            <option key={index} value={comp.price_id}>
                                                {comp.product_name}-{comp.category_name}-
                                                {comp.type_name}-{comp.quantity_remain}P-
                                                {comp.min_price}rwf
                                                </option>
                                        )):<option>no product</option>
                                    }
                                </select>
                            </div>
                            <label className="form-label">Quantity</label>
                            <input required min="1"
                                type="number"
                                name="quantity_used"
                                value={toQuantity}
                                onChange={(e) => settoQuantity(e.target.value)}
                                className="form-control"
                            />    
                        </div>
                        <button className="btn btn-primary w-25 m-2 rounded">Send</button>
                    </div>
                </div>
            </form>  

            <div style={loading?{display:"block"}:{display:"none"}}>
                <AppLoading />
            </div>         
        </div>
    );
};